import GATSBY_COMPILED_MDX from "/vercel/path0/content/blogs/How-I-made-this-portfolio/index.mdx";
import React, {useState} from "react";
import {MDXProvider} from "@mdx-js/react";
import {SEO} from "@/components/seo";
import styled from "styled-components";
import QuickInfo from "@/components/blog.page/QuickInfo";
import Accordion from "@/components/Reusable/Accordion";
import Spacer from "@/components/Reusable/Spacer";
import {ArrowUp} from "react-feather";
import {Disqus} from "gatsby-plugin-disqus";
import {useSiteMetadata} from "@/hooks/use-site-metadata";
import {useLocation} from "@reach/router";
const StyledHeader = styled.header.withConfig({
  displayName: "blog__StyledHeader",
  componentId: "sc-kxnkyl-0"
})(["font-family:var(--font-serif-ogg);font-size:var(--fz-heading);margin:2em 0;display:flex;flex-direction:column;justify-content:center;align-items:center;text-align:center;line-height:1.2em;small{color:", ";}@media (min-width:786px){font-size:var(--fz-headingxl);margin:2em 0;}"], _ref => {
  let {theme} = _ref;
  return theme.colors.descfont;
});
const StyledInfo = styled.div.withConfig({
  displayName: "blog__StyledInfo",
  componentId: "sc-kxnkyl-1"
})(["", ";gap:0.5em;font-size:var(--fz-md);text-align:center;@media (min-width:786px){font-size:var(--fz-lg);gap:0.5em;}"], _ref2 => {
  let {theme} = _ref2;
  return theme.mixins.flex.flexStart;
});
const StyledTableOfContents = styled.div.withConfig({
  displayName: "blog__StyledTableOfContents",
  componentId: "sc-kxnkyl-2"
})(["margin:2em 0;a{", ";color:", ";}"], _ref3 => {
  let {theme} = _ref3;
  return theme.mixins.components.link;
}, _ref4 => {
  let {theme} = _ref4;
  return theme.colors.descfont;
});
const StyledContent = styled.div.withConfig({
  displayName: "blog__StyledContent",
  componentId: "sc-kxnkyl-3"
})(["text-align:left;p{font-size:var(--fz-md);line-height:1.7;font-weight:400;color:", ";strong{font-weight:500;}}h1,h2{color:", ";font-family:var(--font-serif-ogg);font-weight:600;font-size:var(--fz-xxl);margin:1em 0;}h3{font-size:var(--fz-xl);color:", ";font-family:var(--font-serif-ogg);font-weight:600;margin:0.5em 0;}a{", ";}ol,ul{margin:0;padding:0;list-style:none;color:", ";font-weight:300;}ul{list-style-type:disc;display:block;list-style-type:disc;margin-block-start:1em;margin-block-end:1em;margin-inline-start:0px;margin-inline-end:0px;padding-inline-start:30px;li{padding-left:10px;margin-bottom:1em;}li::marker{content:\"\u2022\" !important;color:", ";}}ol{counter-reset:orderedlist;display:block;margin-block-start:1em;margin-block-end:1em;margin-inline-start:0px;margin-inline-end:0px;padding-inline-start:30px;li{padding-left:0px;margin-bottom:1em;}li::before{counter-increment:orderedlist;content:counter(orderedlist) \". \";line-height:0.75;width:1.5rem;padding-top:0.25rem;text-align:center;color:", ";font-weight:400;border-radius:0.25em;}}.img{margin:auto;background-color:", ";padding:2em;}figcaption{font-size:var(--fz-xs);color:", ";font-weight:300;margin-top:0.5em;text-align:center;width:100%;font-style:italic;}strong{font-weight:500;}@media (min-width:800px){p{font-size:var(--fz-md);}h1{font-size:var(--fz-heading);}h2{font-size:var(--fz-xxxl);}h3{font-size:var(--fz-xxl);}li{line-height:1.7;}ol{li{padding-left:10px;margin-bottom:1em;}}ul{li{padding-left:10px;margin-bottom:1em;}}}"], _ref5 => {
  let {theme} = _ref5;
  return theme.colors.descfont;
}, _ref6 => {
  let {theme} = _ref6;
  return theme.colors.primary;
}, _ref7 => {
  let {theme} = _ref7;
  return theme.colors.primary;
}, _ref8 => {
  let {theme} = _ref8;
  return theme.mixins.components.link;
}, _ref9 => {
  let {theme} = _ref9;
  return theme.colors.descfont;
}, _ref10 => {
  let {theme} = _ref10;
  return theme.colors.descfont;
}, _ref11 => {
  let {theme} = _ref11;
  return theme.colors.descfont;
}, _ref12 => {
  let {theme} = _ref12;
  return theme.colors.imgcolor;
}, props => props.theme.colors.descfont);
const StyledScrollToTop = styled.div.withConfig({
  displayName: "blog__StyledScrollToTop",
  componentId: "sc-kxnkyl-4"
})(["background:", ";border:var(--border-width-hard) solid ", ";box-shadow:0 0 10px ", ";position:fixed;right:25px;left:auto;bottom:25px;margin:0;padding:1em;z-index:1000;display:flex;justify-content:center;align-items:center;border-radius:50%;background:url(", ");cursor:pointer;"], _ref13 => {
  let {theme} = _ref13;
  return theme.colors.background;
}, _ref14 => {
  let {theme} = _ref14;
  return theme.colors.dborder;
}, _ref15 => {
  let {theme} = _ref15;
  return theme.colors.gradientone;
}, _ref16 => {
  let {theme} = _ref16;
  return theme.imgs.grain;
});
const BlogsTemplate = _ref17 => {
  var _data$mdx, _data$mdx$frontmatter, _data$mdx2, _data$mdx2$frontmatte, _data$mdx2$frontmatte2;
  let {data, children} = _ref17;
  const isBrowser = typeof window !== "undefined";
  const {0: visible, 1: setVisible} = useState(false);
  const location = useLocation();
  const {siteUrl} = useSiteMetadata();
  const disqusConfig = {
    url: "" + (siteUrl + location.pathname),
    identifier: data.mdx.frontmatter.slug,
    title: data.mdx.frontmatter.title
  };
  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };
  const scrollToTop = () => {
    if (isBrowser) {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  if (isBrowser) {
    window.addEventListener("scroll", toggleVisible);
  }
  return React.createElement(React.Fragment, null, React.createElement(StyledHeader, null, data.mdx.frontmatter.title, React.createElement(StyledInfo, null, React.createElement("small", null, data.mdx.frontmatter.date), "\u2022", React.createElement("small", null, data.mdx.frontmatter.type))), React.createElement(QuickInfo, null, React.createElement("div", null, React.createElement(Accordion, {
    title: "TL;DR"
  }, React.createElement(StyledTableOfContents, null, data === null || data === void 0 ? void 0 : (_data$mdx = data.mdx) === null || _data$mdx === void 0 ? void 0 : (_data$mdx$frontmatter = _data$mdx.frontmatter) === null || _data$mdx$frontmatter === void 0 ? void 0 : _data$mdx$frontmatter.tldr))), React.createElement("div", null, React.createElement(Accordion, {
    title: "Table of Contents"
  }, React.createElement(StyledTableOfContents, null, React.createElement("ul", null, data === null || data === void 0 ? void 0 : (_data$mdx2 = data.mdx) === null || _data$mdx2 === void 0 ? void 0 : (_data$mdx2$frontmatte = _data$mdx2.frontmatter) === null || _data$mdx2$frontmatte === void 0 ? void 0 : (_data$mdx2$frontmatte2 = _data$mdx2$frontmatte.tableContent) === null || _data$mdx2$frontmatte2 === void 0 ? void 0 : _data$mdx2$frontmatte2.map(item => {
    return React.createElement("li", null, React.createElement("a", {
      href: item === null || item === void 0 ? void 0 : item.link
    }, item === null || item === void 0 ? void 0 : item.name));
  })))))), React.createElement(StyledContent, null, React.createElement(Spacer, {
    height: "2em"
  }), React.createElement(MDXProvider, null, children), React.createElement(Spacer, {
    height: "2em"
  })), React.createElement(Disqus, {
    config: disqusConfig
  }), React.createElement(StyledScrollToTop, {
    style: {
      display: visible ? "flex" : "none"
    },
    onClick: scrollToTop
  }, React.createElement(ArrowUp, null)));
};
BlogsTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(BlogsTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const Head = _ref18 => {
  var _data$mdx3, _data$mdx3$parent, _data$mdx4, _data$mdx4$parent;
  let {data} = _ref18;
  return React.createElement(SEO, {
    title: data.mdx.frontmatter.title,
    description: data.mdx.frontmatter.description,
    image: data.mdx.frontmatter.poster.publicURL
  }, React.createElement("meta", {
    name: "keywords",
    content: data.mdx.frontmatter.keywords
  }), React.createElement("meta", {
    name: "author",
    content: data.mdx.frontmatter.author
  }), React.createElement("meta", {
    name: "distribution",
    content: "web"
  }), React.createElement("meta", {
    property: "og:type",
    content: "article"
  }), React.createElement("meta", {
    property: "article:published_time",
    content: data.mdx.frontmatter.publishedTime
  }), React.createElement("meta", {
    property: "article:modified_time",
    content: data === null || data === void 0 ? void 0 : (_data$mdx3 = data.mdx) === null || _data$mdx3 === void 0 ? void 0 : (_data$mdx3$parent = _data$mdx3.parent) === null || _data$mdx3$parent === void 0 ? void 0 : _data$mdx3$parent.modifiedTime
  }), React.createElement("meta", {
    property: "article:section",
    content: "Article Section"
  }), React.createElement("meta", {
    property: "article:tag",
    content: "Article Tag"
  }), React.createElement("meta", {
    property: "og:updated_time",
    content: data === null || data === void 0 ? void 0 : (_data$mdx4 = data.mdx) === null || _data$mdx4 === void 0 ? void 0 : (_data$mdx4$parent = _data$mdx4.parent) === null || _data$mdx4$parent === void 0 ? void 0 : _data$mdx4$parent.modifiedTime
  }));
};
const query = "329031767";
